'use client'
import { useState, useEffect } from 'react'
import { publicGetRequest } from 'services/strapi'
import FeatureNews from 'components/FeatureNews'
import NewsRow from 'components/NewsRow'
import InfiniteScroll from 'components/InfiniteScroll'
import { arrayBatch } from 'utils/types'

const defaultImgs = [
  'https://fcp-site-images.s3.eu-west-3.amazonaws.com/POLOABSOLUT_718_c60a8bcf17.JPG',
  'https://fcp-site-images.s3.eu-west-3.amazonaws.com/Padel_Mir_Gran_Slam_126_f0aeca221c.jpg',
  'https://fcp-site-images.s3.eu-west-3.amazonaws.com/DRRZ_3756_6f13083d1d.jpg',
  'https://fcp-site-images.s3.eu-west-3.amazonaws.com/DRRZ_9360_bb87f23991.jpg',
  'https://fcp-site-images.s3.eu-west-3.amazonaws.com/DRRZ_4972_b19f3d1ab4.jpg',
  'https://fcp-site-images.s3.eu-west-3.amazonaws.com/Veterans_dissabte_357_2e6ce72351.jpg',
  'https://fcp-site-images.s3.eu-west-3.amazonaws.com/Veterans_dissabte_130_0d8ab50d84.jpg'
]

const News = () => {
  const [news, setNews] = useState()
  const [newsFeatured, setNewsFeatured] = useState()
  const [pageStart, setPageStart] = useState(0)
  const [pageLimit, setPageLimit] = useState(9)
  const [meta, setMeta] = useState()
  const [loading, setLoading] = useState(true)
  const [lastImgIdx, setLastImgIdx] = useState(0)

  const getNews = async () => {
    setLoading(true)
    const req = await publicGetRequest({
      endpoint: 'NEWS_LIST',
      queryString: `&pagination[start]=${pageStart}&pagination[limit]=${pageLimit}`,
      cacheHours: 0.2
    })
    setMeta(req.meta.pagination)
    let imgIdx = lastImgIdx
    const list = req.data
      .sort(
        (a, b) => new Date(b.attributes.fecha) - new Date(a.attributes.fecha)
      )
      .map((_news) => {
        const news = _news.attributes
        const imgs = news.imagen.data?.attributes.formats
        let img = (imgs?.xlarge || imgs?.large)?.url
        if (!img) {
          img = defaultImgs[imgIdx]
          imgIdx = imgIdx === 6 ? 0 : imgIdx + 1
        }
        setLastImgIdx(imgIdx)
        return {
          ctaLink: `/noticies/${news.slug}`,
          title: news.titulo,
          img: img,
          excerpt: news.extracto,
          ctaText: 'Llegir més',
          position: news.posicion
        }
      })
    if (pageStart === 0) {
      setNewsFeatured(list.slice(0, 1).pop())
      setNews(arrayBatch(list.slice(1, list.length), 2))
      setPageLimit(8)
    } else {
      setNews((prev) => [...new Set([...prev, ...arrayBatch(list, 2)])])
    }
    setLoading(false)
  }

  useEffect(() => {
    getNews()
  }, [pageStart])

  return (
    <>
      <div className="bg-sec-grey-4 py-14 mb-8">
        <div className="max-w-screen-2xl ml-16">
          <h1 className="font-alliance-tight text-blue text-[58px] lg:text-[110px]">
            Notícies
          </h1>
        </div>
      </div>
      <div className="bg-white">
        {news && (
          <>
            <FeatureNews {...newsFeatured} />
            <NewsRow newsList={news} />
          </>
        )}
        {meta && (
          <InfiniteScroll
            page={pageStart}
            setPage={setPageStart}
            pageSize={pageLimit}
            loading={loading}
            totalResults={meta.total}
            isOffset={true}
            limitPagination={500}
          />
        )}
      </div>
    </>
  )
}

export default News
